import React, { Component, Fragment } from 'react';
import Navbar from '../Navbar/Navbaranim';
import Main from './Main/Main';
import Banners from './Banners/Banners';
import Display from './Display/Display';
import Features from './Features/Features';
import Recognized from './RecognizedBy/RecognizedBy';
import Booking from './Booking/Booking';
import Footer from '../Footer/Footer';

export default class ProductPage extends Component {
    render() {
        return (
            <Fragment>
                <Navbar />
                <Main />
                <Banners />
                <Display />
                <Features />
                <Booking />
                <Recognized />
                <Footer />
            </Fragment>
        )
    }
}